import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

const showOnTablet = media.tablet`
    display: block;
`;
const ShowOnMobile = styled.div`
  display: none;
  ${showOnTablet};
`;

export default ShowOnMobile;
